import "../Style/Component/Skeleton.css";

export const TableSkeleton = ({ rows = 8, columns = [] }) => {
  return (
    <div className="table-skeleton-wrapper">
      {/* Header / Filters Skeleton */}
      {/* <div className="table-skeleton-header">
        <div className="sk-filters">
          <div className="sk-input skeleton"></div>
          <div className="sk-input skeleton"></div>
          <div className="sk-input skeleton"></div>
          <div className="sk-input skeleton"></div>
          <div className="sk-input skeleton"></div>
        </div>
      </div> */}

      {/* Table Header */}
      <div className="sk-table-head">
        {columns.map((col, index) => (
          <span key={index}>{col}</span>
        ))}
      </div>

      {/* Table Rows */}
      {Array.from({ length: rows }).map((_, i) => (
        <div className="sk-table-row" key={i}>
          <div className="sk-line xs skeleton"></div>
          <div className="sk-line sm skeleton"></div>
          <div className="sk-line lg skeleton"></div>
          <div className="sk-line sm skeleton"></div>
          <div className="sk-line xs skeleton"></div>
          <div className="sk-line sm skeleton"></div>
          <div className="sk-line md skeleton"></div>
          <div className="sk-actions">
            <div className="sk-circle skeleton"></div>
            <div className="sk-btn skeleton"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const Locationcard = () => {
  return (
    <div className="dsrow">
      {/* Total Dealers Card */}
      <div className="sk-card total-dealers-sk skeleton ">
        <div className="sk-overlay">
          <div className="sk-line sm skeleton"></div>
          <div className="sk-line lg skeleton"></div>
        </div>
      </div>
      <div className="sk-card total-dealers-sk skeleton">
        <div className="sk-overlay">
          <div className="sk-line sm skeleton"></div>
          <div className="sk-line lg skeleton"></div>
        </div>
      </div>
      <div className="sk-card total-dealers-sk skeleton">
        <div className="sk-overlay">
          <div className="sk-line sm skeleton"></div>
          <div className="sk-line lg skeleton"></div>
        </div>
      </div>
    </div>
  );
};

export const DashboardSkeleton = () => {
  return (
    <div className="dashboard-skeleton">
      {/* Total Dealers Card */}
      <div className="dsrow">
        <div className="sk-card total-dealers-sk skeleton ">
          <div className="sk-overlay">
            <div className="sk-line sm skeleton"></div>
            <div className="sk-line lg skeleton"></div>
          </div>
        </div>
        <div className="sk-card total-dealers-sk skeleton">
          <div className="sk-overlay">
            <div className="sk-line sm skeleton"></div>
            <div className="sk-line lg skeleton"></div>
          </div>
        </div>
        <div className="sk-card total-dealers-sk skeleton">
          <div className="sk-overlay">
            <div className="sk-line sm skeleton"></div>
            <div className="sk-line lg skeleton"></div>
          </div>
        </div>
      </div>
      <div className="dsrow">
        <div className="sk-card total-dealers-sk skeleton">
          <div className="sk-overlay">
            <div className="sk-line sm skeleton"></div>
            <div className="sk-line lg skeleton"></div>
          </div>
        </div>
        <div className="sk-card total-dealers-sk skeleton">
          <div className="sk-overlay">
            <div className="sk-line sm skeleton"></div>
            <div className="sk-line lg skeleton"></div>
          </div>
        </div>
        <div className="sk-card total-dealers-sk skeleton">
          <div className="sk-overlay">
            <div className="sk-line sm skeleton"></div>
            <div className="sk-line lg skeleton"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CardSkeleton = ({ color }) => (
  <div className="card-shimmer-modern">
    {/* Top Header */}
    <div className="shimmer-header">
      <div className="shimmer-subheading"></div>
      <div className="shimmer-header-actions">
        <div className="shimmer-action-icon"></div>
      </div>
    </div>

    {/* Main Content */}
    <div className="shimmer-main-content">
      <div className="shimmer-value-container">
        <div className="shimmer-main-value"></div>
        <div className="shimmer-value-subtext"></div>
      </div>

      <div className="shimmer-logo-container">
        <div
          className="shimmer-logo"
          style={{ backgroundColor: `var(--${color}-light)` }}
        ></div>
      </div>

      {/* Right Side - Count/Main Value */}
    </div>

    {/* Bottom Subheading */}
    <div className="shimmer-bottom-section">
      <div className="shimmer-subheading"></div>
    </div>
  </div>
);

export const ChartSkeleton = () => (
  <div className="chart-shimmer-modern">
    <div className="chart-header-modern">
      <div className="chart-title-modern"></div>
      <div className="chart-controls-modern">
        <div className="control-item-modern"></div>
        <div className="control-item-modern"></div>
        <div className="control-item-modern"></div>
      </div>
    </div>
    <div className="chartbottom">
      <div className="chartgraph">
        <div className="chart-body-modern">
          <div className="y-axis-modern">
            <div className="y-tick"></div>
            <div className="y-tick"></div>
            <div className="y-tick"></div>
            <div className="y-tick"></div>
            <div className="y-tick"></div>
            <div className="y-tick"></div>
          </div>

          <div className="chart-graph-modern">
            <div className="grid-lines-modern">
              <div className="grid-line"></div>
              <div className="grid-line"></div>
              <div className="grid-line"></div>
              <div className="grid-line"></div>
              <div className="grid-line"></div>
              <div className="grid-line"></div>
            </div>
          </div>
        </div>

        <div className="x-axis-modern">
          {[...Array(12)].map((_, i) => (
            <div key={i} className="x-label-modern"></div>
          ))}
        </div>
      </div>
      <div className="forcharttopcard">
        <div className="topcard skeleton"></div>
        <div className="topcard skeleton"></div>
      </div>
    </div>
  </div>
);

export const UserCardSkeleton = () => {
  return (
    <div className="user-card-skeleton-wrapper">
      {Array.from({ length: 8 }).map((_, index) => (
        <div className="user-card-skeleton" key={index}>
          {/* Image Skeleton */}
          <div className="user-image-skeleton skeleton"></div>

          {/* Details */}
          <div className="user-details-skeleton skeleton">
            {/* <div className="detail-line skeleton"></div>
            <div className="detail-line skeleton"></div>
            <div className="detail-line skeleton"></div> */}
          </div>
        </div>
      ))}
    </div>
  );
};

export const NotificationbannerSke = ({ count = 2 }) => {
  return (
    <div className="flash-skeleton-wrapper">
      {Array.from({ length: count }).map((_, idx) => (
        <div className="flash-skeleton-card" key={idx}>
          <div className="flash-skeleton-image"></div>
          <div className="flash-skeleton-text"></div>
          <div className="flash-skeleton-button"></div>
        </div>
      ))}
    </div>
  );
};

export const OrdersSkeleton = () => {
  return (
    <div className="order-banner-skel">
      <div className="order-banner-bg-skel"></div>

      <div className="order-banner-content-skel">
        <div className="order-banner-title-skel"></div>

        <div className="order-banner-actions-skel">
          <div className="order-banner-input-skel"></div>
          <div className="order-banner-btn-skel"></div>
        </div>
      </div>
    </div>
  );
};

export const AssignOrderPageSkeleton = () => {
  return (
    <div className="assign-skel-layout">
      {/* LEFT SIDE (Cards) */}
      <div className="assign-skel-left">
        {[1, 2, 3, 4].map((_, i) => (
          <AssignCardSkeleton key={i} />
        ))}
      </div>

      {/* RIGHT SIDE (Available Admin Team) */}
      <div className="assign-skel-right">
        <AvailableTeamSkeleton />
      </div>
    </div>
  );
};
export const AssignCardSkeleton = () => {
  return (
    <div className="assign-card-skel">
      <div className="assign-img-skel skeleton"></div>

      <div className="assign-text-skel">
        <div className="line short skeleton"></div>
        <div className="line medium"></div>
      </div>

      <div className="assign-arrow-skel skeleton"></div>
    </div>
  );
};

export const AvailableTeamSkeleton = () => {
  return (
    <div className="team-skel">
      <div className="team-title-skel"></div>

      {[1, 2, 3, 4, 5].map((_, i) => (
        <div className="team-card-skel" key={i}>
          <div className="avatar-skel skeleton"></div>
          <div className="team-text-skel">
            <div className="name-skel skeleton"></div>
            <div className="status-skel skeleton"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const VehicleCardSkeleton = () => {
  return (
    <div className="vehicle-skeleton-card">
      {/* Left Image Section */}
      <div className="vehicle-image-section">
        <div className="vehicle-image skeleton"></div>
      </div>

      {/* Right Pricing Section */}
      <div className="vehicle-pricing-section">
        <div className="price-box skeleton"></div>
        <div className="price-box skeleton"></div>
        <div className="price-box skeleton"></div>
        <div className="price-box skeleton"></div>
        <div className="user-actions-skeleton">
          <div className="btn-skeleton cancel shimmer"></div>
          <div className="btn-skeleton approve shimmer"></div>
        </div>
      </div>
      <div className="vehicle-image-section">
        <div className="vehicle-image skeleton"></div>
      </div>

      {/* Right Pricing Section */}
      <div className="vehicle-pricing-section">
        <div className="price-box skeleton"></div>
        <div className="price-box skeleton"></div>
        <div className="price-box skeleton"></div>
        <div className="price-box skeleton"></div>
        <div className="user-actions-skeleton">
          <div className="btn-skeleton cancel shimmer"></div>
          <div className="btn-skeleton approve shimmer"></div>
        </div>
      </div>
    </div>
  );
};

export const WalletPageSkeleton = () => {
  return (
    <>
      <div className="wallet-page-skeleton">
        {/* Two Tables */}
        <div className="wallet-tables">
          {[1, 2].map((table) => (
            <div key={table} className="wallet-table-skeleton">
              {/* Header Row */}
              <div className="table-header-skeleton">
                <div className="th shimmer"></div>
                <div className="th shimmer"></div>
                <div className="th shimmer"></div>
                <div className="th shimmer"></div>
              </div>

              {/* 8 Rows */}
              {[...Array(8)].map((_, i) => (
                <div key={i} className="table-row-skeleton">
                  <div className="td small shimmer"></div>
                  <div className="td shimmer"></div>
                  <div className="td shimmer"></div>
                  <div className="td wallet shimmer"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export const BannerSkeleton = () => {
  return (
    <div className="banner-skeleton-wrapper">
      {[1, 2].map((_, index) => (
        <div className="banner-skeleton-card" key={index}>
          {/* Top Label */}
          <div className="skeleton skeleton-badge"></div>

          {/* Image */}
          <div className="skeleton skeleton-image"></div>

          {/* Inputs */}
          <div className="skeleton skeleton-input"></div>
          <div className="skeleton skeleton-input"></div>
          <div className="skeleton skeleton-input"></div>
          <div className="skeleton skeleton-input"></div>

          {/* Buttons */}
          <div className="skeleton-button-row">
            <div className="skeleton skeleton-btn"></div>
            <div className="skeleton skeleton-btn confirm"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const IssueCardSkeleton = () => {
  return (
    <>
      <div className="issue-skeleton-card">
        {/* Left Circle Icon */}
        <div className="skeleton skeleton-circle"></div>

        <div className="issue-skeleton-content">
          {/* Top Row */}
          <div className="issue-skeleton-header">
            <div className="skeleton skeleton-name"></div>
            <div className="skeleton skeleton-time"></div>
          </div>

          {/* Message Line */}
          <div className="skeleton skeleton-text"></div>

          {/* Bottom Row */}
          <div className="issue-skeleton-footer">
            <div className="skeleton skeleton-eye"></div>
            <div className="skeleton skeleton-status"></div>
          </div>
        </div>
      </div>
      <div className="issue-skeleton-card">
        {/* Left Circle Icon */}
        <div className="skeleton skeleton-circle"></div>

        <div className="issue-skeleton-content">
          {/* Top Row */}
          <div className="issue-skeleton-header">
            <div className="skeleton skeleton-name"></div>
            <div className="skeleton skeleton-time"></div>
          </div>

          {/* Message Line */}
          <div className="skeleton skeleton-text"></div>

          {/* Bottom Row */}
          <div className="issue-skeleton-footer">
            <div className="skeleton skeleton-eye"></div>
            <div className="skeleton skeleton-status"></div>
          </div>
        </div>
      </div>
      <div className="issue-skeleton-card">
        {/* Left Circle Icon */}
        <div className="skeleton skeleton-circle"></div>

        <div className="issue-skeleton-content">
          {/* Top Row */}
          <div className="issue-skeleton-header">
            <div className="skeleton skeleton-name"></div>
            <div className="skeleton skeleton-time"></div>
          </div>

          {/* Message Line */}
          <div className="skeleton skeleton-text"></div>

          {/* Bottom Row */}
          <div className="issue-skeleton-footer">
            <div className="skeleton skeleton-eye"></div>
            <div className="skeleton skeleton-status"></div>
          </div>
        </div>
      </div>
      <div className="issue-skeleton-card">
        {/* Left Circle Icon */}
        <div className="skeleton skeleton-circle"></div>

        <div className="issue-skeleton-content">
          {/* Top Row */}
          <div className="issue-skeleton-header">
            <div className="skeleton skeleton-name"></div>
            <div className="skeleton skeleton-time"></div>
          </div>

          {/* Message Line */}
          <div className="skeleton skeleton-text"></div>

          {/* Bottom Row */}
          <div className="issue-skeleton-footer">
            <div className="skeleton skeleton-eye"></div>
            <div className="skeleton skeleton-status"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export const ProfilePageSkeleton = () => {
  return (
    <div className="profile-skeleton">
      {/* LEFT SIDE */}
      <div className="profile-skeleton-left">
        <div className="skeleton skeleton-back"></div>

        <div className="skeleton skeleton-avatar large"></div>

        <div className="skeleton skeleton-name"></div>
        <div className="skeleton skeleton-role"></div>

        <div className="profile-skeleton-card">
          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-input small"></div>

          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-input small"></div>

          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-input small"></div>

          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-input small"></div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="profile-skeleton-right">
        {/* Tabs */}
        <div className="profile-skeleton-tabs">
          {Array(5)
            .fill(0)
            .map((_, i) => (
              <div key={i} className="skeleton skeleton-tab"></div>
            ))}
        </div>

        {/* Profile Image */}
        <div className="profile-skeleton-image-section">
          <div className="skeleton skeleton-avatar"></div>
          <div className="skeleton skeleton-button"></div>
        </div>

        {/* Form Fields */}
        <div className="profile-skeleton-form">
          {Array(3)
            .fill(0)
            .map((_, i) => (
              <div key={i}>
                <div className="skeleton skeleton-label"></div>
                <div className="skeleton skeleton-input"></div>
              </div>
            ))}

          {/* Row fields */}
          <div className="profile-skeleton-row">
            <div className="skeleton skeleton-input"></div>
            <div className="skeleton skeleton-input"></div>
            <div className="skeleton skeleton-input"></div>
          </div>

          <div className="skeleton skeleton-submit"></div>
        </div>
      </div>
    </div>
  );
};
